export enum CONSTANTS {
    ROW_COUNT = 20,
    LAST_TRANSACTION_COUNT = 2,
    WALLET_STATEMENT_API = '/reports/run',
    WALLET_TOPUP_BAL_ENQ = '/pgtopup/check',
    WALLET_TOPUP_BEGIN = '/pgtopup/begin',
    WALLET_DISPUTE_STATUS = '/disputes/check/',
    PG_TRANSACTION_STATUS = '/pgtopup',
    PG_TRANSACTION_END = '/pgtopup/end',
    SERVICE_REQUEST_API = '/tickets/topics',
    userId = 'C777777',
    LOGIN_TYPE = 'userid',
    SERVICE_REQUEST_TICKETS_API = '/reports/run',
    VEHICLE_LISTING_API = '/reports/run',
    VEHICLE_GENERATE_CHALLAN_PDF_API = '/vehicles/challanpdf',
    VEHICLE_DOWNLOAD_CHALLAN_PDF_API = '/files/download',
    LOGIN_API = '/user/fleetlogin',
    PROFILE_API = '/profile',
    ADD_TICKET_API = '/tickets',
    ADD_DISPUTE_API = '/disputes/raise',
    CLOSE_TICKET_API = '/tickets/close',
    DISPUTE_TICKET_DOC_UPLOAD_API = '/disputes/docs/upload/',
    TICKET_ATTACHMENT_LISTS_API = '/tickets/docs/list/',
    DISPUTE_TICKET_ATTACHMENT_LISTS_API = '/disputes/docs/list/',
    VEHICLE_ATTACHMENT_LISTS_API = '/vehicles/docs/list/',
    ATTACHMENT_LISTS_API = '/tickets/docs/list/1804',
    ADD_VEHICLE_API = '/enrollment/addvehicle',
    VEHICLE_CLASS_API = '/lookup/vehicleclass',
    GLOBAL_INIT_API = 'https://driver.1pay.devops.merce.co/apiSample.php',
    LOGOUT_API = '/logout',
    SUBTRACT_DAYS = 90,
    DISPUTE_BTN_DISABLE_DAYS = 45,
    FILESIZE_LIMIT_IN_MB = 5, 
    API_TIMEOUT = 300000,
    DISPUTE_ALERT_MSG = 'A dispute has been raised with id #',
    TICKET_ALERT_MSG = 'Ticket has been successfully created with ticket ID #',
    VEHICLE_ADD_ALERT_MSG = 'Vehicle added successfully',
    OFFLINE_MSG = "Please check your internet connection",
    SHARE_TOP_HEADER = "Sent via 1PAY",
    FORMLY_PLACEHOLDER_TEXT = "Maximum character limit is 50",
    FORMLY_PLACEHOLDER_TEXT_PHONE = "Maximum number length is 10",
    SESSION_ALERT_MSG = 'Your session has timed out. Please log in again.',
    INVALID_FILESIZE_ALERT_MSG = 'File size is more than 5MB..! Please try again.',
    FILESIZE_NOTE_ALERT_MSG = 'Please ensure file size is not more than 5MB.',
    API_TIMEOUT_MSG = 'Failed to complete operation. Please try again later after sometime.',
    SHARE_FOOTER_NOTE = "Install 1PAY FASTag app and move fast with the 1PAY Fastag app, pay for tolls, manage trips expenses and track all your support requests using our elegant and speedy interface.",
    VEHICLE_SUSPEND_API = "/vehicles/suspend/",
    VEHICLE_UNSUSPEND_API = "/vehicles/unsuspend/",
    NO_RECORD = 'No records to load',
    TICKET_STATUS_CNT_API = '/tickets/summary',
    NOTIFICATION_TEST_BTN = 'true',
    PG_MERCE_URL = "https://driver.1pay.devops.merce.co/demo.php",
    PG_1PAY_PROD_URL = "https://1paytag.hdfcbank.com/fleetui/processmtopup.jsp",
    PG_1PAY_UAT_URL = "https://hdfcbankfastag.in/fleetui/processmtopup.jsp",
    TMP_FCM_URL = "http://mobapp01.centralindia.cloudapp.azure.com:8181/fleetapi/rest",
    GET_CHANNELS_API = "/pns/topics",
    SUBSCRIBE_CHANNEL_API = "/pns/subscribe/",
    UNSUBSCRIBE_CHANNEL_API = "/pns/unsubscribe/",
    TOPIC_NOTIFICATION_API = "/pns/topic/send",
    LOCAL_INIT_URL = "/device/register",
    TICKET_DOC_TYPE_API = "/tickets/docs/types",
    TICKET_DOC_UPLOAD_API = "/tickets/docs/upload/",
    VEHICLE_DOC_TYPE_API = "/vehicles/docs/types",
    DISPUTE_DOC_TYPE_API = "/disputes/docs/types",
    VEHICLE_DOC_UPLOAD_API = "/vehicles/docs/upload/",
    VEHICLE_DOC_DOWNLOAD_API = "/vehicles/docs/download/",
    VERIFY_OTP_API = "/verify/otp",
    VERIFY_MOBILE_API = "/verify/mobile",
    GLOBAL_INIT_URL = "https://1move.1pay.in/svclocator/globalinit",
    ACTIVE_VEHICLE_STATUS = "Active",
    VEHICLE_STATUS_COUNT = "/vehicles/summary"
    // MONTH_START = "2021-07-01",
    // MONTH_END = "2021-10-30",
};
export enum COLUMNS {
    id = "id",
    WALLET_TXN_ID = "wallet_txn_id",
    REF_TXN_ID = "ref_txn_id",
    WALLET_ID = "wallet_id",
    TXN_TYPE = "txn_type",
    OPENING_BALANCE = "opening_balance",
    TXN_AMOUNT = "txn_amount",
    CLOSING_BALANCE = "closing_balance",
    SECURITY_DEPOSIT = "security_deposit",
    NARRATION = "narration",
    TXN_DATE = "txn_date",
    PAY_MODE = "pay_mode",
    PARTNER_ID = "partner_id",
    PARTNER_REF_NO = "partner_ref_no",
    UDF1 = "udf1",
    UDF2 = "udf2",
    UDF3 = "udf3",
    UDF4 = "udf4",
    UDF5 = "udf5",
    UDF6 = "udf6",
    UDF7 = "udf7",
    UDF8 = "udf8",
    CREATED_ON = "created_on",
    CREATED_BY = "created_by",
    SOURCE_CHANNEL = "source_channel",
    SOURCE_CHANNEL_IP = "source_channel_ip",
    reader_ts = "reader_ts",
    req_pay_id = "req_pay_id",
    user_id = "user_id",                    // from this - for tickets
    remarks = "remarks",
    data = "data",
    status = "status",
    admin_remark = "admin_remark",
    created_by = "created_by",
    created_on = "created_on",
    last_updated_by = "last_updated_by",
    last_updated_on = "last_updated_on",
    category_id = "category_id",
    category_desc = "category_desc",         // upto this - for tickets
    vehicle_id = "vehicle_id",               // from this - for vehicle list
    vehicle_number = "vehicle_number",
    cust_id = "cust_id",
    vehicle_class_id = "vehicle_class_id",
    tag_class_id = "tag_class_id",
    engine_number = "engine_number",
    chassis_number = "chassis_number",
    is_commercial = "is_commercial",
    is_deleted = "is_deleted",
    rodt = "rodt",
    sms_flag = "sms_flag",
    tid = "tid",
    tag_id = "tag_id",
    customer_id = "customer_id",
    tag_status = "tag_status",
    signature_data = "signature_data",
    barcode_data = "barcode_data",
    tag_pwd = "tag_pwd",
    kill_pwd = "kill_pwd",
    rfu1 = "rfu1",
    rfu2 = "rfu2",
    rfu3 = "rfu3",
    exe_code = "exe_code",                       // upto this - for vehicle list
    vrn = "vrn",
    barcode = "barcode",
    tag_class = "tag_class",
    issuer_ts = "issuer_ts",
    company_name = "company_name",
    customer_type = "customer_type",
    email = "email",
    faillogin_count = "faillogin_count",
    full_name = "full_name",
    kyc_type = "kyc_type",
    last_login_ts = "last_login_ts",
    notification_settings = "notification_settings",
    password_change_ts = "password_change_ts",
    phone = "phone",
    preferences = "preferences",
    primary_address = "primary_address",
    role = "role",
    role_id = "role_id",
    user_type = "user_type",
    wallet_id = "wallet_id",
};


export enum MESSAGES {
    "EMAIL_SENT" = "Email sent successfully"
}
